module.exports = __webpack_public_path__ + "static/media/mockupbrowser.5062400d.png";